/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Formal criteria for a task submission, student facing, part of task definition
This is also used as parameter set to generate the formal criteria for the task
 */
export interface TaskFormalCriteriaConfig {
  wordcount: number;
  wordcountTolerance: number;
  /** @minimum 0 */
  minInTextCitations?: number;
}
